import { Card, CardContent } from "@/components/ui/card";
import { Shield, Award, Users, Clock } from "lucide-react";

const stats = [
  {
    icon: Shield,
    value: "100%",
    label: "HIPAA Compliant",
    description: "All reviewed EMRs meet strict compliance standards"
  },
  {
    icon: Users,
    value: "24/7",
    label: "Expert Support",
    description: "Get personalized recommendations within 1 business day"
  },
  {
    icon: Award,
    value: "20+",
    label: "EMR Systems",
    description: "Actively reviewed and compared for accuracy"
  },
  {
    icon: Clock,
    value: "Free",
    label: "Expert Analysis",
    description: "No cost consultation with EMR specialists"
  }
];

const TrustIndicators = () => {
  return (
    <section className="py-20 px-4 bg-secondary/30">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Why Healthcare Providers Trust Us
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            We provide unbiased, expert analysis to help you make informed decisions for your organization.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const IconComponent = stat.icon;
            return (
              <Card key={index} className="text-center border-border bg-background hover:shadow-lg transition-shadow duration-300">
                <CardContent className="pt-8 pb-6">
                  <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
                      <IconComponent className="w-8 h-8 text-primary" />
                    </div>
                  </div>
                  
                  <div className="text-3xl font-bold text-foreground mb-2">
                    {stat.value}
                  </div>
                  
                  <div className="text-lg font-semibold text-foreground mb-2">
                    {stat.label}
                  </div>
                  
                  <p className="text-sm text-muted-foreground">
                    {stat.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustIndicators;